import React from "react";

const VideoIcon = ({ color, size = 30 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
    <path
      fill={color}
      fillRule="evenodd"
      d="M7 10h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9a2 2 0 0
      1 2-2zm6 10l6-3.5-6-3.5v7zM9 6h12a1 1 0 0 1 0 2H9a1 1 0 1 1 0-2z"
    />
  </svg>
);

export default VideoIcon;
